import { gql } from '@apollo/client';

const SUBTASK_TEMPLATE_CREATE = gql`
  mutation SubTaskTemplateCreate($input: SubTaskTemplateCreateInput!) {
    subTaskTemplateCreate(input: $input) {
      __typename
      errors {
        error
        message
      }
      subTaskTemplate {
        answerType
        answerOptions
        id
        label
        position
        __typename
      }
    }
  }
`;

export default SUBTASK_TEMPLATE_CREATE;
